import Breadcrumb from "component/common/breadcrumb";
import TableDataNotFound from "component/TableDataNotFound";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getSupportForumList,
  supportForumStatusUpdate,
} from "reduxStore/action/supportForumAction";
import strings from "translate/language";
import { handleListResponse, seo } from "utils/utils";
import usePermission from "utils/usePermission";
import usePage from "utils/usePage";
import Pagination from "component/common/Pagination";
import moment from "moment";

const SupportForum = () => {
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [handleStatus, setHandleStatus] = useState({});
  const [supportFormData, setSupportFormData] = useState([]);
  const [page, setPage] = usePage();
  const dispatch = useDispatch();
  const supportFormListSelector =
    useSelector((state) => state.supportForum) || [];

  const { create, view, edit } = usePermission({
    create: "add_support_forum",
    view: "view_support_forum",
    edit: "edit_support_forum",
  });
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    search_title: "",
    search_location: "",
    search_description: "",
  });

  useEffect(() => {
    dispatch(getSupportForumList({ limit: 10, offset: page }));
  }, []);

  useEffect(() => {
    if (supportFormListSelector.create) {
      if (supportFormListSelector?.response?.status === 200) {
        if (handleStatus.support_forum_id) {
          dispatch(getSupportForumList({ limit: 10, offset: page }));
        }
        setHandleStatus({});
      }
    } else {
      if (supportFormListSelector?.response?.status === 200) {
        if (supportFormListSelector?.response?.data?.length > 0) {
          setSupportFormData(
            handleListResponse(supportFormListSelector?.response?.data)
              ? supportFormListSelector?.response?.data
              : []
          );
        }
      } else {
        setSupportFormData([]);
      }
    }
  }, [supportFormListSelector]);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        getSupportForumList({
          limit: 10,
          offset: 0,
          start_date: form.start_date,
          end_date: form.end_date,
          search_title: form.search_title,
          search_location: form.search_location,
          search_description: form.search_description,
        })
      );
      setPage(0);
    }
  };
  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      limit: "",
      offset: "",
      search_title: "",
      search_location: "",
      search_description: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: ""
    })
    dispatch(getSupportForumList({ limit: 10, offset: 0 }));
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handleStatusUpdate = () => {
    dispatch(supportForumStatusUpdate(handleStatus));
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: ""
      })
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    dispatch(
      getSupportForumList({
        limit: 10,
        offset: newOffset,
        start_date: form.start_date,
        end_date: form.end_date,
        search_title: form.search_title,
        search_location: form.search_location,
        search_description: form.search_description,
      })
    );
  };

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Support Forum Listing",
      metaDescription: "Support forum listing",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      {/* Model_start */}
      <div
        className="modal fade"
        id="exampleModal1"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabe2">
                {handleStatus.status === 1
                  ? strings.activeSupportForum
                  : strings.deactiveSupportForum}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="text-center">
                <h6>{strings.areYouSure}</h6>
              </p>
              <p className="text-center">
                <h6>
                  {handleStatus.status === 1
                    ? strings.activeThisSupportForm
                    : strings.deactiveThis}
                </h6>
              </p>
            </div>
            <div className="modal-footer justify-content-center ">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handleStatusUpdate()}
                data-dismiss="modal"
              >
                {strings.yes}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.no}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Model_end */}
      <Breadcrumb
        title={strings.supportForum}
        parentListing={null}
        titleactive={strings.supportForumList}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByLocation}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              autoComplete="off"
                              name="search_location"
                              value={form.search_location}
                              onChange={handleInputField}
                              placeholder={strings.searchLocation}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4  ">
                          <span className="cardText">
                            {strings.searchByTitle}{" "}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              autoComplete="off"
                              name="search_title"
                              value={form.search_title}
                              onChange={handleInputField}
                              placeholder={strings.searchTitle}
                            />
                          </div>
                        </div>
                        <div className="col-md-4  ">
                          <span className="cardText">
                            {strings.searchByDescription}
                          </span>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="text"
                            autoComplete="off"
                            name="search_description"
                            value={form.search_description}
                            onChange={handleInputField}
                            placeholder={strings.searchDescription}
                          />
                        </div>
                        <div className="col-md-4 pt-4 ">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {create && (
              <div className="row pt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <button
                      className="btn btn-color"
                      type="button"
                      onClick={() => navigatpage("/addnewsupportforum")}
                    >
                      {strings.addnewsupportforum}
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listOfSupportForum}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead>
                        <tr>
                          <th scope="col" className="text-center">
                            {strings.images}
                          </th>
                          <th scope="col" className="text-center">
                            {strings.title}
                          </th>
                          <th scope="col" className="text-center">
                            {strings.createdDate}
                          </th>
                          <th scope="col">{strings.location}</th>
                          <th scope="col">{strings.description}</th>
                          <th scope="col" className="text-center">
                            {strings.status}
                          </th>
                          <th scope="col" className="text-center">
                            {strings.action}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {supportFormData?.length > 0 ? (
                          supportFormData.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className="text-center">
                                  <img
                                    src={
                                      item?.document?.length > 0
                                        ? item.base_url +
                                        item?.document[0]?.content
                                        : "assets/images/property.png"
                                    }
                                    className="user img-fluid"
                                    alt=""
                                    type="file"
                                  />
                                </td>
                                <td className="text-center">
                                  {item?.title
                                    ? item?.title.length > 20
                                      ? item?.title.substring(0, 20) + "..."
                                      : item?.title
                                    : "-"}
                                </td>

                                <td className="text-center">
                                  {" "}
                                  {moment(item.createdDate).format(
                                    "DD-MM-yyyy hh:mm a"
                                  )}
                                </td>
                                <td>
                                  <div>
                                    {item?.location
                                      ? item?.location.length > 25
                                        ? item?.location.substring(0, 25) +
                                        "..."
                                        : item?.location
                                      : "-"}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    {item?.description
                                      ? item?.description.length > 20
                                        ? item?.description.substring(0, 20) +
                                        "..."
                                        : item?.description
                                      : "-"}
                                  </div>
                                </td>
                                <td
                                  className="text-center"
                                  style={{
                                    color: item.status ? "green" : "red",
                                    fontWeight: item.status ? "800" : "800",
                                  }}
                                >
                                  {item.status ? "Active" : "Deactive"}
                                </td>
                                <td className="text-center p-2">
                                  {view && (
                                    <i
                                      className="fa fa-eye theme-fa-icon p-2"
                                      aria-hidden="true"
                                      title={strings.viewSupportForum}
                                      onClick={() =>
                                        navigatpage(
                                          `/viewsupportforum/${item._id}`
                                        )
                                      }
                                    ></i>
                                  )}
                                  {edit && (
                                    <i
                                      className="fa fa-edit theme-fa-icon"
                                      aria-hidden="true"
                                      title={strings.editsupportforum}
                                      onClick={() =>
                                        navigatpage(
                                          `/editsupportforum/${item._id}`
                                        )
                                      }
                                    ></i>
                                  )}
                                  {edit &&
                                    (item.status ? (
                                      <i
                                        className="fa fa-ban theme-fa-icon p-2"
                                        aria-hidden="true"
                                        title={strings.deactiveSupportForum}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal1"
                                        onClick={() =>
                                          setHandleStatus({
                                            support_forum_id: item._id,
                                            status: 2,
                                          })
                                        }
                                      ></i>
                                    ) : (
                                      <i
                                        className="fa fa-unlock theme-fa-icon p-2"
                                        aria-hidden="true"
                                        title={strings.activeSupportForum}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal1"
                                        onClick={() =>
                                          setHandleStatus({
                                            support_forum_id: item._id,
                                            status: 1,
                                          })
                                        }
                                      ></i>
                                    ))}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={supportFormData} />
                  </div>
                  <Pagination
                    totalCount={supportFormListSelector?.response?.total_data}
                    listData={supportFormData}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SupportForum;
